export type TaskIconColorKey =
  | "MANUAL"
  | "DOCUMENT"
  | "APPROVAL"
  | "QUALITY_EVENT"
  | "TRAINING";

type TaskIconColors = {
  icon: string;
  background: string;
};

export const TASK_ICON_COLORS: Record<TaskIconColorKey, TaskIconColors> = {
  MANUAL: {
    icon: "rgb(76, 183, 130)",
    background: "rgba(76, 183, 130, 0.173)",
  },
  APPROVAL: {
    icon: "rgb(93, 133, 255)",
    background: "rgba(93, 133, 255, 0.173)",
  },
  QUALITY_EVENT: {
    icon: "rgb(93, 133, 255)",
    background: "rgba(93, 133, 255, 0.173)",
  },
  DOCUMENT: {
    icon: "rgb(235, 87, 87)",
    background: "rgba(235, 87, 87, 0.173)",
  },
  TRAINING: {
    icon: "rgb(155, 89, 182)",
    background: "rgba(155, 89, 182, 0.173)",
  },
};
